import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { endpoints } from "@/lib/api";
import { useCached } from "@/lib/fbCache";

const score = (m) => (m.status === "scheduled" ? new Date(m.ts * 1000).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : `${m.homeScore ?? 0}–${m.awayScore ?? 0}`);

// Thin live-score strip on the radio player — only on Rwanda Premier League match days.
export const RwandaTicker = () => {
  const q = useCached("rw-ticker", () => endpoints.rwTicker(), 55e3, 60e3);
  const d = q.data;
  if (!d?.show || !d.matches?.length) return null;
  const items = d.matches.map((m) => (
    <span key={m.id} className="inline-flex items-center gap-1.5 px-4 whitespace-nowrap" data-testid={`rw-ticker-${m.id}`}>
      {m.status === "live" && <span className="w-1.5 h-1.5 rounded-full bg-[#EF4444] live-dot" />}
      <span className="text-white font-semibold">{m.home}</span>
      <b className={m.status === "live" ? "text-[#EF4444]" : "text-white"}>{score(m)}</b>
      <span className="text-white font-semibold">{m.away}</span>
      <span className="text-[10px] text-slate-300">{m.status === "live" ? m.label : m.status === "finished" ? "FT" : ""}</span>
    </span>));
  return (
    <Link to="/football/east-africa?c=405" className="flex items-center h-7 border-b border-white/10 bg-black/60 overflow-hidden text-xs" data-testid="rw-ticker">
      <span className="shrink-0 h-full px-3 flex items-center bg-[#E11D2A] text-white font-extrabold uppercase tracking-wide text-[10px]">{d.live ? "Live" : "Today"} · RPL</span>
      <div className="flex-1 overflow-hidden"><div className="rw-marquee inline-flex">{items}{items}</div></div>
    </Link>
  );
};

export const RwandaScorers = () => {
  const q = useCached("rw-scorers", () => endpoints.rwScorers(), 30 * 60e3);
  const rows = q.data?.scorers || [];
  if (!q.data) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-[#E11D2A]" /></div>;
  if (!rows.length) return <p className="text-slate-300 text-center py-10" data-testid="rw-scorers-empty">No goals recorded yet this season.</p>;
  return (
    <div className="rounded-xl border border-white/15 overflow-hidden bg-black" data-testid="rw-scorers">
      <div className="px-4 py-3 text-sm font-bold text-white border-b border-white/10">Rwanda Premier League top scorers{q.data.season ? ` · ${q.data.season}` : ""}</div>
      <table className="w-full text-sm">
        <thead className="text-[11px] uppercase tracking-wider text-slate-300 bg-white/5"><tr><th className="p-3 text-left w-10">#</th><th className="p-3 text-left">Player</th><th className="p-3 text-left">Club</th><th className="p-3 text-right">Goals</th></tr></thead>
        <tbody>{rows.map((r, i) => (
          <tr key={`${r.name}-${r.team}`} className="border-t border-white/10" data-testid={`rw-scorer-${i}`}>
            <td className={`p-3 font-extrabold ${i < 3 ? "text-[#E11D2A]" : "text-slate-300"}`}>{i + 1}</td>
            <td className="p-3 text-white font-semibold">{r.name}</td>
            <td className="p-3"><span className="flex items-center gap-2 text-slate-200">{r.teamLogo && <img src={r.teamLogo} alt="" className="w-5 h-5 object-contain" />}{r.team}</span></td>
            <td className="p-3 text-right text-white font-extrabold text-base">{r.goals}</td>
          </tr>))}</tbody>
      </table>
    </div>
  );
};
